/* @flow */
"use strict";

/*@__PURE__*/function noop() {}

// Just reexport
var render /*: (
  app: React$Element<any>,
  root: Element & { unmountApp?: () => void },
  onComplete?: () => void
) => void */ = (require("react-dom").hydrate /*: any */);
var watch /*: (
  devServer: ?{ host?: string, port?: number },
  manifestPath: ?string
) => void  */ = (noop /*: any */);
var watchReload /*: (
  devServer: Location
) => void */ = (noop /*: any */);

if (process.env.NODE_ENV !== "production") {
  var dev = require("./index.development.js");

  render = dev.render;
  watch = dev.watch;
  watchReload = dev.watchReload;
}

module.exports.render = render;
module.exports.watch = watch;
module.exports.watchReload = watchReload;
